<storever-loading-data *ngIf="isLoadingBlock else dataForm"></storever-loading-data>
<ng-template #dataForm>
<form  [ngClass]="stylingClass" [formGroup]="form">
  <ng-container
    *ngFor="let field of inputConfig;"
    storeverDynamicField
    [config]="field"
    [group]="form"
    [isAdd]="isAdd"
    [isEdit]="isEdit"
    [isExchange]="isExchange"
    [orderType]="orderType">
  </ng-container>
  <ng-content select="[order-switch]"></ng-content>
</form>
</ng-template>
<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
  (3)dynamic-form
  <!--  <pre style="flex:1;word-break:break-word;line-height:2;">{{form.get(['subscription', 'network', 'proxy']).value|json}}</pre>-->
  <pre style="flex:1;word-break:break-word;line-height:2;">{{form.value|json}}</pre>
  <div style="flex:1;word-break:break-word;line-height:2;">{{getInvalidControls(form)}}</div>
</div>
